<template>
    <div class="invited-page">
        <div class="my-card">
            <div class="top-bg"></div>
            <div class="invited-info">
                <div class="dark-text">欢迎加入&nbsp;{{teacherInfo.companyName}}</div>
                <div class="grey-text">来自&nbsp;{{teacherInfo.name}}{{teacherInfo.phone}}&nbsp;的邀请</div>
            </div>
            <div class="form-wrapper">
                <van-form @submit="onSubmit" ref="invitedForm">
                    <van-field
                        v-model="username"
                        name="姓名"
                        label="姓名"
                        placeholder="请输入用户名"
                        maxlength="20"
                        :rules="[{ required: true, message: '用户名不能为空' }]"
                    />
                    <van-field
                        v-model="phone"
                        type="tel"
                        name="手机号码"
                        label="手机号码"
                        placeholder="请输入手机号码"
                        maxlength="11"
                        :rules="[{ pattern: new RegExp(/^1\d{10}$/), message: '手机号码格式不正确'}]"
                    />
                    <van-field
                        v-model="smsCode"
                        name="短信验证码"
                        placeholder="请输入短信验证码"
                        maxlength="4"
                        ref="codeInput"
                        :rules="[{ required: true, message: '短信验证码不能为空' }]">
                        <template #button>
                            <van-button native-type="button" size="small" type="primary" :disabled="isSending" @click="sendSMSCode">
                                {{isSending?'重新发送('+secondNum+')':'发送验证码'}}
                            </van-button>
                        </template>
                    </van-field>
                    <div style="margin: 16px;">
                        <van-button square round block type="primary" :loading="submiting" :loading-text="'提交中...'" native-type="submit">
                            立即加入
                        </van-button>
                    </div>
                    <span>{{pcode}}</span>
                </van-form>
            </div>
        </div>
        <div class="invite-tips">点击立即加入代表您已阅读并同意《用户服务协议》</div>
    </div>
</template>

<script>
export default {
    name: "people-invited",
    data() {
        return {
            pageTitle: "邀请加入",
            campusName: "",
            teacherInfo: {}, // 老师信息
            username: '',
            phone: '',
            smsCode: '',
            isSending: false,
            secondNum: 10,
            timer: null,
            pcode: '',
            submiting: false
        }
    },
    methods: {
        refreshQrCode() {
            vant.Dialog.confirm({
                title: '提示',
                message: '刷新后之前的邀请链接、二维码都将失效，是否确认刷新？',
            }).then(() => {
                // on confirm
                this.$toast.success('ok');
            }).catch(() => {
                // on cancel
                this.$toast('刷新已取消');
            });
        },
        getTeacherInfo() {
            this.$api.getTeacherById({
                id: this.$route.query.teacherId
            }).then(res=>{
                if (res.code === 200) {
                    this.teacherInfo = res.data;
                }
            })
        },
        sendSMSCode() {
            this.$refs.invitedForm.validate('手机号码').then(() => {
                // console.log('发送短信验证码')
                this.isSending = true;
                this.secondNum = 60;
                this.sendSMSCodeApi(); 
            }).catch((err) => {
                console.error(err);
            });
        },
        onSubmit() {
            this.$refs.invitedForm.validate().then(() => {
                this.submiting = true
                let {teacherId} = this.$route.query
                let {companyId} = this.teacherInfo
                this.$api.registerInvite({
                    verifyCode: this.smsCode,
                    companyId,
                    phone: this.phone,
                    teacherId,
                    name: this.username,
                    wxOpenId: this.$route.query.wxOpenId,
                    thirdAppId: this.$route.query.thirdAppId
                }).then(res=>{
                    if (res.code === 200) {
                        app.ls.set("x3-teacher-token", res.data.token);
                        location.href = `${location.origin}/app/teacher${location.search}`;
                    } else {
                        this.$toast.fail(res.msg);
                    }
                    this.submiting = false
                })
                .catch((err) => {
                    console.error(err);
                    this.submiting = false
                });
            })
            .catch((err) => {
                console.error(err);
            });
        },
        sendSMSCodeApi() {
            this.$refs.codeInput.focus();
            this.$api.codeSms({
                phone: this.phone,
            }).then(res=> {
                if (res.code === 200) {
                    this.$toast.success("获取验证码成功,请注意查收");
                    this.timer = setInterval(()=>{
                        if (this.secondNum <= 0) {
                            clearInterval(this.timer);
                            this.timer = null;
                            this.isSending = false;
                        } else {
                            this.secondNum--;
                        }
                    }, 1000)
                    this.pcode = res.data;
                } else {
                    this.$toast.fail(res.msg);
                }

            })
            .catch((err) => {
                
                this.$toast.fail("服务出错，请稍后重试");
                console.error(err);
            });
        }
    },
    created() {
        this.getTeacherInfo();
    },
    mounted() {
    },
}
</script>

<style lang="scss" scoped>
.invited-page{
    background: var(--white);
    .grey-text{
        font-size: var(--fs-sm);
        color: var(--g6);
    }
    .my-card {
        .top-bg {
            height: 106px;
            background: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/simple/invited-people.png) center center no-repeat;
            background-size: contain;
        }
        .invited-info {
           text-align: center;
        }
        .form-wrapper {
            margin-top: 20px;
        }
        .dark-text {
            font-size: var(--fs-lg);
            font-weight: 500;
            line-height: 24px;
            margin-top: 16px;
        }
    }
    .invite-tips {
        text-align: center;
        color: var(--g6);
        font-size: 11px;
        margin-bottom: 10px;
    }
    ::v-deep .van-cell {
        margin-bottom: 16px;
    }
}
</style>